<script lang="ts">
  import { onMount } from "svelte"
  import PrevNextSkipButtons from "./components/PrevNextSkipButtons.svelte"
  import Navigation from "./Navigation.svelte"
  import { onboardingStore } from "./onboarding.svelte"

  onboardingStore.completed = true

  onMount(() => {
    onboardingStore.setBrowserHistory({}, "founders_message")
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step="founders_message" on:updateStep />

    <div class="px-6 lg:px-12 my-12 w-full max-w-5xl mx-auto">
      <h2 class="mt-12 text-5xl font-bold text-center text-white">
        A Message from our Founder and CEO, Marc Koehler
      </h2>
      <h3 class="mt-4 text-2xl text-white mb-8">
        Watch this welcome message from Marc Koehler and then click Continue to
        proceed.
      </h3>

      <div class="relative" style="padding-top: 56.25%">
        <iframe
          src="https://player.vimeo.com/video/747823487"
          class="absolute inset-0 w-full h-full"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
          title="E1 Course"
        ></iframe>
      </div>
    </div>

    <PrevNextSkipButtons
      css="justify-evenly"
      skipContCss="text-center"
      showSkip={false}
    />
  </div>
</div>
